// Single source of truth for "last updated" labels shown across the site.
// Bump these three values on every data refresh — components, footer, modal
// and How-It-Works all read from here so nothing drifts.
export const siteMeta = {
  updateLabel: 'Q3 2026 Update',          // short badge text
  updatedOn: 'September 5, 2026',         // human-readable refresh date
  updatedOnISO: '2026-09-05',             // for machine-readable contexts
  nextReview: 'Q4 2026 (December)',       // planned next refresh
  cadence: 'Quarterly',                   // stated update cadence
  lawCount: '125+',
  jurisdictionCount: 18,
};
